<script>import { fade } from "svelte/transition";
import { attrValue } from "../../utils/html";
export let title = "";
export let content = "";
export let classNames;
export let id = null;
export let textCenter = true;
export let width;
export let placement = "top";
export let variant = "default";
export let fixedTooltipArrowPosition;
export let tooltipNode = null;
</script>

<div
	class:text-center={textCenter}
	class:pointer-events-none={!$$slots.default}
	class={attrValue(['tooltip ', classNames, width])}
	class:error={variant === 'error'}
	class:hint={variant === 'hint'}
	data-popper-placement={placement}
	{id}
	bind:this={tooltipNode}
	in:fade
	out:fade
>
	<div class="inner">
		{#if title}
			{@html title}
		{/if}
		{#if $$slots.default}
			<slot />
		{:else if content}
			<div class="text-sm italic first-letter:uppercase text-left">
				{@html content}
			</div>
		{/if}
	</div>
	<div
		class="arrow {fixedTooltipArrowPosition ? 'left-1/2 transform -translate-x-1/2' : ''}"
		data-popper-arrow
	/>
</div>

<style>.tooltip{--arrow-distance:-0.25rem;--arrow-bg:#000;--tooltip-bg:#000;--tooltip-text:#fff;--tooltip-padding:0.5rem;max-width:500px;position:relative;z-index:1999}.inner{background-color:var(--tooltip-bg);border-radius:.25rem;color:var(--tooltip-text);font-size:.875rem;line-height:1.25rem;padding:var(--tooltip-padding);position:relative;z-index:1}.arrow{visibility:hidden}.arrow,.arrow:before{height:.5rem;position:absolute;width:.5rem;z-index:-1}.arrow:before{background-color:var(--arrow-bg);content:"";left:0;top:0;transform:rotate(45deg);transform-origin:center center;visibility:visible}[data-popper-placement^=top] .arrow{bottom:var(--arrow-distance)}[data-popper-placement^=bottom] .arrow{top:var(--arrow-distance)}[data-popper-placement^=left] .arrow{right:var(--arrow-distance)}[data-popper-placement^=right] .arrow{left:var(--arrow-distance)}.error{--tooltip-bg:#fff;--tooltip-text:#000;--arrow-bg:#e73e11;border-radius:.25rem;border-width:1px;display:inline-block;margin-top:.5rem;--tw-border-opacity:1;border-color:#e73e11;border-color:rgba(231,62,17,var(--tw-border-opacity,1))}.error .inner{margin-left:auto}.error .arrow{right:1.3rem}.hint{--tooltip-bg:#fff;--tooltip-text:#e6e6e6;--tooltip-padding:0.25rem;--arrow-bg:#f7f7f7;max-width:7rem}.hint .inner{border-width:1px;display:inline-block;--tw-border-opacity:1;border-color:#f7f7f7;border-color:rgba(247,247,247,var(--tw-border-opacity,1))}.hint .arrow{right:1.5rem}</style>
